import { render, staticRenderFns } from "./DifferentiatingBenefitsBannerSection.vue?vue&type=template&id=396cab8e"
import script from "./DifferentiatingBenefitsBannerSection.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefitsBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./DifferentiatingBenefitsBannerSection.vue?vue&type=style&index=0&id=396cab8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports